import type { TourDefinition } from '../types';

export const dealProfileTour: TourDefinition = {
  id: 'deal-profile',
  title: 'Perfil do Negócio',
  steps: [
    {
      element: '[data-tour="deal-top-bar"]',
      popover: {
        title: 'Cabeçalho do Negócio',
        description:
          'Veja o nome, valor, lead/empresa vinculada e ações rápidas do negócio.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="deal-pipeline-bar"]',
      popover: {
        title: 'Etapas do Pipeline',
        description:
          'Visualize e altere a etapa atual do negócio clicando na fase desejada.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="deal-left-sidebar"]',
      popover: {
        title: 'Contexto e Ações',
        description:
          'Tags, informações do contato e ações rápidas como ligar, enviar email ou WhatsApp.',
        side: 'right',
        align: 'start',
      },
    },
    {
      element: '[data-tour="deal-timeline"]',
      popover: {
        title: 'Timeline de Atividades',
        description:
          'Veja todo o histórico de interações, notas e atividades do negócio.',
        side: 'left',
        align: 'center',
      },
    },
    {
      element: '[data-tour="deal-right-sidebar"]',
      popover: {
        title: 'Resumo e Follow-ups',
        description:
          'Resumo do negócio, próximos passos, agende follow-ups e crie tarefas.',
        side: 'left',
        align: 'start',
      },
    },
  ],
};
